import { render } from "./SearchProvider.vue?vue&type=template&id=7be3d9cc&scoped=true"
import script from "./SearchProvider.vue?vue&type=script&lang=js"
export * from "./SearchProvider.vue?vue&type=script&lang=js"

import "./SearchProvider.vue?vue&type=style&index=0&id=7be3d9cc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7be3d9cc"]])

export default __exports__